import { CollectionTypeTicket } from 'meta/pages/collection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequest } from 'utils/http'

type Params = {
  id: string
}

export const getSeasons = async (params: Params): Promise<CollectionTypeTicket[]> => {
  const { id } = params

  const { data } = await HttpRequest.get<CollectionTypeTicket[]>(ApiEndpoint.performer.seasons(id))

  return data
}
